import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async fetchTractVisitTypes (context) {
    const response = await ApiServer.get('tractVisitTypes')
    const sortedData = response.data.sort((a, b) => a.name.localeCompare(b.name))
    context.commit('setTractVisitTypes', sortedData)
    return sortedData
  },

  async deleteTractVisitType (context, tractVisitTypeId) {
    const response = await ApiServer.delete(`tractVisitTypes/${tractVisitTypeId}`)
    context.commit('removeTractVisitType', tractVisitTypeId)
    return response.data
  },

  async createTractVisitType (context, tractVisitType) {
    const response = await ApiServer.post('tractVisitTypes', tractVisitType)
    context.commit('addTractVisitType', response.data)
    return response.data
  },

  async updateTractVisitType (context, tractVisitType) {
    const response = await ApiServer.put(`tractVisitTypes/${tractVisitType.tractVisitTypeId}`, tractVisitType)
    context.commit('updateTractVisitType', tractVisitType)
    return response.data
  }
}
